// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--3GG1y","text":"index-module--text--n6B4o","image":"index-module--image--kqC51","caption":"index-module--caption--zDGFi"};